{
  "$comment": "The closed set of semantic states a screen-level or feature-level gallery must account for. Every semantic gallery declares, for each state, either the case ids that cover it or an audited reason the design does not specify it. Shared by galleryTypes.ts (runtime validation) and src/features/semanticGalleryContract.mjs (the generator's RN-free twin), so the list exists exactly once.",
  "states": [
    "loading",
    "empty",
    "error",
    "populated",
    "modal-sheet",
    "interaction"
  ]
}
